export const loggingEvents = {
  listing: {
    view: 'buyer_listing_view',
    requestNda: 'buyer_listing_request_nda',
  },
  auth: {
    focusEmailInput: 'buyer_auth_focus_email_input',
    submitEmail: 'buyer_auth_submit_email',
    focusOtpInput: 'buyer_auth_focus_otp_input',
    submitOtp: 'buyer_auth_submit_otp',
    submitUserInfo: 'buyer_auth_submit_user_info',
  },
  ndaModal: {
    submitRequestInfo: 'buyer_nda_modal_submit_request_info',
    downloadNda: 'buyer_nda_modal_download_nda',
    signNdaStart: 'buyer_nda_modal_sign_nda_start',
    signNdaLoaded: 'buyer_nda_modal_sign_nda_loaded',
    signNdaSuccess: 'buyer_nda_modal_sign_nda_success',
  },
};
